<template>
  <keep-alive include="home">
    <router-view />
  </keep-alive>
</template>

<style lang="scss">
body{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: white;
}
p{
  margin: 0;
}
</style>
